module.exports = __webpack_public_path__ + "static/img/kf1.7dbb241a.svg";